"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    purchaseOrder: 'Inleverans' || 'purchaseOrder',
    writeOrder: 'Spara order' || 'writeOrder',
    placeOrder: 'Begär inleverans' || 'placeOrder',
    addRemark: 'Lägg anmärkning på inleverans' || 'addRemark',
    setArcNumber: 'Lägg till ARC-nummer' || 'setArcNumber',
    markAsEmcsProcessed: 'Markera EMCS som klar' || 'markAsEmcsProcessed',
    sendToSupplier: 'Godkänn inleverans' || 'sendToSupplier',
    resendOrder: 'Skicka order mail igen' || 'resendOrder',
    shipOrder: 'Skickad från leverantör' || 'shipOrder',
    markAsReceived: 'Ankommit till lagret' || 'markAsReceived',
    cancel: 'Makulera' || 'cancel',
    removeRow: 'Ta bort' || 'removeRow',
    removeSuggestionRows: 'Ta bort automatiskt föreslagna rader' || 'removeSuggestionRows',
    resupplyArticle: 'Lägg till artikel på inleverans' || 'resupplyArticle',
    changeDeliveryDate: 'Ändra leveransdatum' || 'changeDeliveryDate',
    processDelivery: 'Leverera in gods' || 'processDelivery',
    ensureInvariants: 'Räkna om totaler' || 'ensureInvariants',
    downloadEmcs: 'Ladda ner EMCS' || 'downloadEMCS',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    orderNumber: 'Ordernummer' || 'orderNumber',
    supplierOrderNumber: 'Leverantörens ordernummer' || 'supplierOrderNumber',
    purchaseOrderState: 'Status' || 'purchaseOrderState',
    purchaseOrderStates: {
        draft: 'Utkast' || 'draft',
        waitingForFlaivyApproval: 'Granskas' || 'waitingForFlaivyApproval',
        sentToSupplier: 'Beställd' || 'sentToSupplier',
        shipped: 'På väg' || 'shipped',
        received: 'Mottagen' || 'received',
        partialyDelivered: 'Delleverans' || 'partialyDelivered',
        delivered: 'Levererad' || 'delivered',
    },
    supplierMessage: 'Meddelande till leverantör' || 'supplierMessage',
    deliveryDate: 'Beräknat leveransdatum' || 'deliveryDate',
    receivedDate: 'Datum då leveransen kom till lagret' || 'receivedDate',
    cancelled: 'Makulerad' || 'cancelled',
    owningSupplierOrganization: 'Leverantörorganisation' || 'owningSupplierOrganization',
    trackingCode: 'Spårningskod' || 'trackingCode',
    ARCNumber: 'ARC-nummer' || 'ARCNumber',
    requiresEMCS: 'Behöver EMCS?' || 'requiresEMCS',
    isEMCSProcessed: 'Är EMCS-processad?' || 'isEMCSProcessed',
    targetWarehouse: 'Till lager' || 'targetWarehouse',
    targetWarehouses: {
        vinden: 'Kungsängen' || 'vinden',
        exacta: 'Karlskoga' || 'exacta',
    },
    remarks: 'Kommentarer' || 'remarks',
    orderFullfillmentCenter: 'Lagerställe' || 'orderFullfillmentCenter',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    hasInactiveArticle: 'Finns utgångna artiklar på lager' || 'hasInactiveArticle',
    handledByFlaivy: 'Behöver specialhantering av flaivy' || 'handledByFlaivy',
    purchaseOrderRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        orderedQuantity: 'Enheter i leverans' || 'orderedQuantity',
        receivedQuantity: 'Mottaget antal' || 'receivedQuantity',
        orderedParcels: 'Beställda kollin' || 'orderedParcels',
        receivedParcels: 'Motagna kollin' || 'receivedParcels',
        price: 'Inköpspris/styck' || 'price',
        isSuggestion: 'Automatisk föreslagen påfyllning' || 'isSuggestion',
    },
    purchaseOrderDeliveries: {
        id: 'Identitet' || 'id',
        deliveryRows: 'Leverans rader' || 'deliveryRows',
        deliveryId: 'Leveransnummer' || 'deliveryId',
        deliveryDate: 'Leveransnummer' || 'deliveryDate',
    },
};
